import * as zod from 'zod'

export const detailsSchema = zod.object({
  positionName: zod.string().nonempty('Position name is required'),
  description: zod.string().nonempty('Description is required'),
  isShiftLeadPosition: zod.boolean().optional(),
})

export type DetailsForm = zod.infer<typeof detailsSchema>
